export function copy(text: string) {
    return window.OK.clipboard.copy(text);
}
